import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { take } from 'rxjs/operators';

@Injectable()
export class OneClickSetContract implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .select(getOneClickSelectedOrder)
      .pipe(take(1))
      .subscribe((order) => {
        const modded: Order = {
          ...order,
          items: order.items.map((item, index) => {
            if (index === form.mapItem[index]) {
              return {
                ...item,
                agreementItem: value ? { ...item.agreementItem, agreementItemId: value } : undefined,
              };
            } else {
              return item;
            }
          }),
        };

        this.store.dispatch(new OneClickUpdateOrderAction(modded));
      });
  }
}
